/** Pinned journey choice for people who have not picked an exam yet. Not a catalog cert. */
export const EXPLORING_CERTIFICATION = "Exploring certifications";

export function isExploringCertification(name: string | null | undefined): boolean {
  return (name ?? "").trim().toLowerCase() === EXPLORING_CERTIFICATION.toLowerCase();
}

/** Empty when the label is the exploring pin, so onboarding does not treat it as an exam. */
export function specificCertification(name: string | null | undefined): string {
  const trimmed = (name ?? "").trim();
  return isExploringCertification(trimmed) ? "" : trimmed;
}
